<div>
  <ng-container *ngIf="props.type === 'multipleimagepreview'">
    <label class="form-label fg-label" for="{{ props.field_Name }}">{{ props.label }}
      <span class="text-danger" *ngIf="props.required">*</span>
      <span style="font-size: x-small; margin-left: 0.5rem" *ngIf="props.noteMsg !== ''">{{ props.noteMsg }}</span>
    </label>
  </ng-container>
  <ng-container *ngIf="props.type === 'singleimagepreview'">
    <br />
    <div class="d-flex align-items-center">
      <div class="input-group" *ngIf="
          fileName === undefined || fileName === ''
        ">
        <div class="custom-file">
          <input type="file" class="custom-file-input btn-grad" id="inputGroupFile04"
            (change)="onFileSelected($event ,editModel.data)" accept=".pdf, .jpg, .jpeg, .png" />
          <label class="custom-file-label" for="inputGroupFile04"><img src="assets/images/Upload.png"
              class="mx-2" />Upload
            Documents</label>
        </div>
      </div>
      <div class="input-group" *ngIf="
          fileName !== undefined && fileName !== '' && fileName !== undefined
        ">
        <input type="input" [readonly]="true" class="form-control border-right-0"
          [value]="truncateFileName(fileName, 40)" (click)="downloadAchievement(editModel.data, fileOriginalName)"/>

        <div class="input-group-append border-left-0">
          <span class="input-group-text pull-right remove-icon custom-upload-icon border-left-0" id="">
            <i class="upload-icon"></i>
          </span>
          <span class="input-group-text pull-right remove-icon custom-upload-icon border-left-0" id="">
            <i class="delete-icon" (click)="deleteUploadDocument(editModel?.data)"></i>
          </span>
        </div>
      </div>

    </div>
  </ng-container>



  <ng-container *ngIf="props.type === 'multitypeimagepreview'">

    <div class="d-flex flex-column flex-md-row justify-content-between p-3">
      <div class="d-flex justify-content-start p-3">
        <label for="{{ props.field_Name }}">{{ editModel?.data.fileName }}
        </label>
      </div>
      <label class="form-label fg-label" for="{{ props.field_Name }}">{{ props.label }}
        <span class="text-danger" *ngIf="props.required">*</span>
        <span style="font-size: x-small; margin-left: 0.5rem" *ngIf="props.noteMsg !== ''">{{ props.noteMsg }}</span>
      </label><br />

      <div class="d-flex align-items-center">
        <div class="input-group" *ngIf="
            fileName === undefined || fileName === '' || fileName === undefined
          ">
          <div class="custom-file">
            <input type="file" accept="application/pdf,application/vnd.ms-excel/,application/png"
              class="custom-file-input btn-grad" id="inputGroupFile04" (change)="onFileSelected($event,editModel.data)"
              accept=".pdf, .jpg, .jpeg, .png" id="file" />
            <label class="custom-file-label" for="inputGroupFile04"><img src="assets/images/Upload.png"
                class="mx-2" />Upload
              Documents</label>
          </div>
        </div>
        <div>
          <div class="input-group border-right-0 file-input" *ngIf="
              fileName !== undefined && fileName !== '' && fileName !== undefined
            ">
            <input type="text" class="form-control background-color-input border-right-0 cursorHand"
              [value]="truncateFileName(fileName, 40)" (click)="downloadDocument(editModel.data, fileName)" />

            <div class="input-group-append border-left-0">
              <span class="input-group-text pull-right remove-icon custom-remove-icon border-left-0"
                (click)="deleteUploadDocument(editModel?.data)" id="">X</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="props.type === 'PDF'">
    <label class="form-label fg-label" for="{{ props.field_Name }}">{{ props.label }} <span class="text-danger"
        *ngIf="props.required">*</span> <span style="font-size: x-small; margin-left: 0.5rem"
        *ngIf="props.noteMsg !== ''">{{ props.noteMsg }}</span>
    </label>
    <br />
    <div class="d-flex align-items-center">
      <button class="btn-sm btn-primary" (click)="file.click()">Upload File</button><span class="px-1"
        *ngIf="fileName !== undefined && fileName !== ''" (click)="open(pdfviewer)">
        -
        <span class="d-inline-block text-truncate" style="max-width: 200px;"> <!-- Adjust max-width as needed -->
          <a class="text-decoration-underline font-weight-bold" role="button" style="color: var(--blue)"
            title="{{ fileName }}">
            {{ truncateFileName(fileName, 40) }}
          </a>
        </span>
      </span>

      <input #file type="file" accept="application/pdf,application/vnd.ms-excel"
        (change)="selectFiles($event, ss.contentType)" id="file" style="display: none" /><br />
    </div>
  </ng-container>
  <!-- <sm-error [control]="formcontrol"></sm-error> -->
  <div class="error-container">
    <sm-error [control]="formcontrol" [label]="props.label"></sm-error>
  </div>


</div>
<ng-template #pdfviewer let-c="close" let-d="dismiss">
  <div class="modal-header">
    <p class="mt-2 text-capitalize pdf-header">{{ pdfHeader === null ? '' : pdfHeader }}</p>
    <!-- <button type="button" class="btn btn-close" aria-label="Close" (click)="d('Cross click')"></button> -->
       <button type="button" class="btn-close no-sky-outline" aria-label="Close"
      (click)="d('Cross click')"><span
      aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body text-center" style="height: 69vh; overflow-y: hidden">
    <iframe [src]="previews[previews.length - 1]" width="100%" height="100%" frameborder="0"
      *ngIf="editModel !== null && viewerType === 'ANY'"></iframe>
    <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false" style="width: auto; height: 69vh" #pdfViewer
      *ngIf="viewerType === 'PDF'"></pdf-viewer>
    <video autoplay id="video1" width="auto" height="350vh" class="img" controls
      *ngIf="previews.length > 0 && viewerType === 'VID'">
      <source [src]="previews[previews.length - 1]" type="video/mp4" />
    </video>
    <img [src]="previews[previews.length - 1]" width="500" height="350" class="preview mx-3"
      *ngIf="previews.length > 0 && viewerType === 'IMG'" />
  </div>
</ng-template>